import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AssetsCustomActionSchemaWithId } from '@iconik-io/iconik-api/src/services/assets';

import type { CustomActionsState } from './types';

const initialState: CustomActionsState = {
  customActions: [],
  customActionsContexts: {
    NONE: [],
    SAVED_SEARCH: [],
    COLLECTION: [],
    ASSET: [],
    SHARED_ASSET: [],
    SHARED_COLLECTION: [],
    PLAYLIST: [],
    SHARED_PLAYLIST: [],
    BULK: [],
    ASSET_SUBCLIP: [],
  },
};

export const customActionsSlice = createSlice({
  name: 'customActions',
  initialState,
  reducers: {
    setCustomActions(
      state,
      action: PayloadAction<AssetsCustomActionSchemaWithId[]>,
    ) {
      state.customActions = action.payload;
      state.customActionsContexts = {
        NONE: [],
        SAVED_SEARCH: [],
        COLLECTION: [],
        ASSET: [],
        SHARED_ASSET: [],
        SHARED_COLLECTION: [],
        PLAYLIST: [],
        SHARED_PLAYLIST: [],
        BULK: [],
        ASSET_SUBCLIP: [],
      };
      action.payload.forEach((customAction) => {
        const { context } = customAction;
        if (context && state.customActionsContexts[context]) {
          state.customActionsContexts[context].push(customAction);
        }
      });
    },
  },
});

export const { setCustomActions } = customActionsSlice.actions;

export const customActionsReducer = customActionsSlice.reducer;
